<p class="v-text msg" *ngIf="oemId === 'new-osaka'; else default">
  本サービスのご利用には<label class="msg" style="color: #bc3131"
    >発生届ID(HERSYS ID)</label
  >または<label class="msg" style="color: #bc3131">陽性者登録ID</label
  >が必要です。<br />
  ※上記IDはアカウント作成後にご登録いただきます。ご登録いただかないとオンライン診療を実施できない場合があります。
</p>
<ng-template #default>
  <p class="v-text msg">
    【{{ pref }}】新型コロナオンライン診療ステーションは所定の抗原検査キットで
    <label class="msg" style="color: #bc3131">『陽性』の方のみ</label
    >が対象です。
  </p>
</ng-template>
